export default __webpack_public_path__ + "static/media/Settings_Filled_Active.8fd659c9.svg";